var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNepalMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1031.45 518.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 21.53,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 12.01,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 31.04,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 40.56,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 50.07,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 59.59,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 69.11,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 78.62,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 88.14,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 97.65,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 107.17,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 116.68,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.05,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 126.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 135.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 145.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 154.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.05,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 164.26,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.27,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.05,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 173.78,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.27,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.05,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 183.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.5,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.27,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.05,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 192.81,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.5,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.27,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.05,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 202.33,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.05,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 211.84,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.82,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.93,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 221.36,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.6,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.37,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.7,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 230.87,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.15,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.48,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.25,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 240.39,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.8,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 249.91,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.58,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.36,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 259.42,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 268.94,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.13,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 278.45,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.68,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 178.46,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 287.97,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.91,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 188.24,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 297.48,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.01,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.79,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 307,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.56,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 246.89,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.67,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 316.52,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 227.34,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.11,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.44,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1028.95,
    cy: 326.03,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.22,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 285.99,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1028.95,
    cy: 335.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.77,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.54,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.32,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 325.1,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.87,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 345.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 354.58,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 344.65,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 364.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 354.42,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.2,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 373.97,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 383.75,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.53,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.63,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 442.4,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452.18,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.96,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 501.06,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 510.83,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.61,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 530.39,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 373.61,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 403.3,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.85,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.73,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 481.51,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.16,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 549.94,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 559.71,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 383.13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 413.08,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 491.28,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 569.49,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 392.64,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 402.16,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 411.67,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 421.19,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 579.26,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 589.04,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.82,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.59,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 430.7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 618.37,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 440.22,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 628.14,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 637.92,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 706.35,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 449.74,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 647.7,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 677.02,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.8,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1028.95,
    cy: 459.25,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 657.47,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 667.25,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1028.95,
    cy: 468.77,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 716.13,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.45,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 755.23,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 765,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 774.78,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 784.56,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 478.28,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 725.9,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.68,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 794.33,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 804.11,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 813.88,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 872.54,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 882.31,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 487.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.66,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.43,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 862.76,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 980.07,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 989.85,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1019.17,
    cy: 497.32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 843.21,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.99,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 892.09,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 901.86,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 911.64,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 931.19,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.97,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 950.74,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.52,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.29,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 999.62,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 506.83,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 921.42,
    cy: 516.35,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1009.4,
    cy: 516.35,
    r: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepalMap);
export default __webpack_public_path__ + "static/media/nepal-map.7b2008ebd1160e05054bec312fc3e05e.svg";
export { ForwardRef as ReactComponent };